import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const demoLink = "https://calendly.com/avishkar-easemytkt/30min";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container nav-content">
        <div className="logo">
          <span className="logo-text">Raptic<span className="logo-accent">91</span><sup>™</sup></span>
        </div>

        <div className="nav-links desktop-only">
          <a href="#platform">Platform</a>
          <a href="#solutions">Solutions</a>
          <a href="#security">Security</a>
          <a href="#how-it-works">How it Works</a>
        </div>

        <div className="nav-actions desktop-only">
          <button className="btn btn-secondary btn-sm">Sign In</button>
          <a href={demoLink} className="btn btn-primary btn-sm">Book Demo</a>
        </div>

        <button className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu glass">
          <div className="container mobile-nav-links">
            <a href="#platform" onClick={() => setMobileMenuOpen(false)}>Platform</a>
            <a href="#solutions" onClick={() => setMobileMenuOpen(false)}>Solutions</a>
            <a href="#security" onClick={() => setMobileMenuOpen(false)}>Security</a>
            <a href="#how-it-works" onClick={() => setMobileMenuOpen(false)}>How it Works</a>
            <div className="mobile-nav-actions">
              <button className="btn btn-secondary w-full">Sign In</button>
              <a href={demoLink} className="btn btn-primary w-full">Book Demo</a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
